export default "__VITE_ASSET__FV9YWq$h__"